<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8 mb-2">
        <div class="card h-100">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Producto</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save" :disabled="isSaving">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-8">
                <label for="example-text-input" class="form-control-label">Nombre</label>
                <argon-input type="text" v-model="form.name" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Referencia</label>
                <argon-input type="text" v-model="form.ref" />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <argon-textarea type="text" v-model="form.description" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Stock</label>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="form.quantity" :disabled="form.id != 0" />
                </div>
                <small v-if="form.id != 0" class="text-xxs text-muted">Use "Ajustar" en Movimientos de stock para cambiarlo.</small>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Precio de compra</label>
                <argon-input type="text" v-model="form.price" />
              </div>

              

              <div class="col-md-12 d-flex align-items-center mt-4 mb-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="manageStock"
                    v-model="form.manage_stock"
                  />
                  <label class="form-check-label ms-2" for="manageStock">
                    Manejar stock del insumo
                  </label>
                </div>
              </div>

              <br>
              <hr>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant mininima</label>
                <argon-input type="text" v-model="form.low" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant media</label>
                <argon-input type="text" v-model="form.medium" />
              </div>

              <div class="col-md-4">
                <label for="example-text-input" class="form-control-label">Cant alta</label>
                <argon-input type="text" v-model="form.high" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Bodega</label>
                <select name="" id="" class="form-select" v-model="form.bodega_id">
                  <option value="">Seleccionar</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status">
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
                </select>
              </div>

            </div>
          </div>
        </div>

      </div>

      <!-- Movimientos de stock: ajustes manuales y usos en producción -->
      <div class="col-md-4 mb-2 movements-col" v-if="form.id!=0">
        <div class="card movements-card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Movimientos de stock</p>
              <argon-button color="primary" size="sm" class="ms-auto" @click="openModal">
                <i class="fas fa-exchange-alt me-1"></i> Ajustar
              </argon-button>
            </div>
            <span v-if="!form.manage_stock" class="text-xxs text-warning">Este insumo no maneja stock</span>
          </div>
          <div class="card-body pt-2 pb-2 movements-body">
            <div v-if="isLoadingMovements" class="text-center p-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            </div>
            <div v-else class="table-responsive">
              <table class="table table-sm align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Fecha</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant.</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Observación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Stock</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in data" :key="item.id">
                    <td class="align-middle ps-2">
                      <span class="text-xs d-block">{{ formatDate(item.created_at) }}</span>
                      <span v-if="item.user" class="text-xxs text-secondary">{{ item.user.name }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-xs font-weight-bold"
                        :class="item.quantity_change > 0 ? 'text-success' : (item.quantity_change < 0 ? 'text-danger' : 'text-secondary')">
                        {{ item.quantity_change > 0 ? '+' : '' }}{{ formatQty(item.quantity_change) }}
                      </span>
                    </td>
                    <td class="align-middle" style="white-space: normal; min-width: 120px;">
                      <span class="text-xs">{{ item.observation || '—' }}</span>
                      <router-link v-if="item.production_id"
                        :to="{ name: 'Production Create', query: { id: item.production_id } }"
                        class="text-xxs text-primary d-block">
                        Ver producción #{{ item.production_id }}
                      </router-link>
                    </td>
                    <td class="align-middle text-center text-xs">
                      {{ item.stock_after !== null ? formatQty(item.stock_after) : '—' }}
                    </td>
                    <td class="align-middle text-end pe-2">
                      <a v-if="item.type !== 'production'" @click="deleteRegister(item.id)"
                        class="text-secondary text-xs cursor-pointer" title="Eliminar ajuste (revierte el stock)">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="data.length === 0">
                    <td colspan="5" class="text-center text-xxs">No hay movimientos registrados</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="lastPage > 1" class="d-flex justify-content-between align-items-center mt-2">
              <button type="button" class="btn btn-outline-secondary btn-sm mb-0" :disabled="currentPage <= 1"
                @click="fetchData(currentPage - 1)">
                <i class="fa fa-chevron-left"></i>
              </button>
              <span class="text-xs">Página {{ currentPage }} de {{ lastPage }}</span>
              <button type="button" class="btn btn-outline-secondary btn-sm mb-0" :disabled="currentPage >= lastPage"
                @click="fetchData(currentPage + 1)">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Ajustar stock</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitForm">

              <div class="mb-3">
                <label class="form-label d-block">Movimiento</label>
                <div class="btn-group w-100" role="group">
                  <button type="button" class="btn mb-0"
                    :class="modal.movement === 'add' ? 'btn-success' : 'btn-outline-success'"
                    @click="modal.movement = 'add'">
                    <i class="fa fa-plus me-1"></i> Sumar
                  </button>
                  <button type="button" class="btn mb-0"
                    :class="modal.movement === 'subtract' ? 'btn-danger' : 'btn-outline-danger'"
                    @click="modal.movement = 'subtract'">
                    <i class="fa fa-minus me-1"></i> Restar
                  </button>
                </div>
              </div>

              <div class="mb-3">
                <label for="movement_quantity" class="form-label">Cantidad</label>
                <input type="number" v-model.number="modal.quantity" id="movement_quantity" class="form-control"
                  min="0" step="any" placeholder="Ingrese la cantidad">
              </div>

              <div class="mb-3">
                <label for="observation" class="form-label">Observación</label>
                <textarea v-model="modal.observation" id="observation" class="form-control"
                  placeholder="Motivo del ajuste (obligatorio)"></textarea>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm" :disabled="isSavingMovement">Guardar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->

  </div>

</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import { mapGetters } from 'vuex';
import inventoryService from "../../../services/inventory.service";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      showMenu: false,
      isSaving: false,
      form: {
        id: 0,
        name: '',
        ref: '',
        description: '',
        quantity: 0,
        status: 0,
        bodega_id: 0,
        price: 0,
        manage_stock: true,
        low: 0,
        medium: 0,
        high: 0,
      },
      modal: {
        id: 0,
        inventory_id: 0,
        movement: 'add',
        quantity: null,
        observation: '',
      },
      isSavingMovement: false,
      isLoadingMovements: false,
      bodegas: [],
      users: [],
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton },
  computed: {
    ...mapGetters('inventoryNews', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.inventoryNews.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.inventoryNews.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['inventoryNews/links']; // Retorna los links
    },
  },
  methods: {
    normalizeBoolean(value) {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === 'string') {
        return value === '1' || value.toLowerCase() === 'true';
      }
      return value === 1 || value === true;
    },
    async fetchData(page = 1) {
      this.isLoadingMovements = true;
      try {
        await this.$store.dispatch('inventoryNews/fetchData', {
          inventory_id: this.form.id,
          page: page || 1,
        });
      } finally {
        this.isLoadingMovements = false;
      }
    },
    formatQty(value) {
      return parseFloat(value || 0).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    formatDate(value) {
      return value ? new Date(value).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' }) : '-';
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("inventory/save", this.form);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          // Actualizar el formulario con los datos guardados
          if (response.data && response.data.data) {
            this.form.id = response.data.data.id || this.form.id;
          }
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El insumo ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          // Redirigir a la lista de insumos (mantener filtro de búsqueda si venía en la URL)
          const search = this.$route.query.search;
          this.$router.push({
            name: 'Supplies',
            query: search
              ? { search: Array.isArray(search) ? search[0] : search }
              : {},
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el proyecto:", error);
        const errData = error?.data || error?.response?.data;
        const msg = errData?.errors?.ref?.[0] || errData?.message || error?.message || 'Error al guardar el proyecto';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    },
    openModal() {
      this.modal = { id: 0, inventory_id: this.form.id, movement: 'add', quantity: null, observation: '' };
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async submitForm() {
      const quantity = parseFloat(this.modal.quantity);
      if (!quantity || quantity <= 0) {
        await Swal.fire({ icon: 'warning', title: 'Cantidad inválida', text: 'Ingrese una cantidad mayor a 0.' });
        return;
      }
      if (!this.modal.observation || !this.modal.observation.trim()) {
        await Swal.fire({ icon: 'warning', title: 'Observación obligatoria', text: 'Indique el motivo del ajuste.' });
        return;
      }

      this.isSavingMovement = true;
      try {
        const response = await this.$store.dispatch("inventoryNews/save", {
          id: 0,
          inventory_id: this.form.id,
          movement: this.modal.movement,
          quantity,
          observation: this.modal.observation.trim(),
        });

        if (response && response.status >= 200 && response.status < 300) {
          this.form.quantity = parseFloat(response.data.data.stock) || 0;
          this.closeModal();
          this.fetchData(1);
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'Stock actualizado correctamente.',
            timer: 1800,
            showConfirmButton: false,
          });
        } else {
          const errors = response?.data?.errors ? Object.values(response.data.errors).flat().join(' ') : '';
          throw new Error(errors || response?.data?.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      } finally {
        this.isSavingMovement = false;
      }

    },
    async editRegister(data) {
      this.modal = data;
      this.openModal();
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Se eliminará el ajuste y se revertirá su efecto en el stock.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("inventoryNews/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El ajuste fue eliminado y el stock revertido.',
              'success'
            );

            await this.refreshStock();
            this.fetchData(this.currentPage);
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || error.message || 'Error al eliminar el registro',
        });
      }
    },
    async refreshStock() {
      try {
        const response = await inventoryService.getData(this.form.id);
        const item = response.data?.data || response.data;
        if (item && item.quantity !== undefined) {
          this.form.quantity = parseFloat(item.quantity) || 0;
        }
      } catch (error) {
        console.error("Error al refrescar el stock:", error);
      }
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },

  },
  mounted() {

    this.getBodegas();


    const route = useRoute();
    const dataEdit = route.params.data;

    console.log(dataEdit);

    if (dataEdit) {
      try {
        const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear


        if (params && params.id) {
          this.form = {
            ...this.form,
            ...params,
            manage_stock: this.normalizeBoolean(params.manage_stock),
          };
          this.fetchData();
        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

/* Movimientos de stock: misma altura que la card de Crear Producto, con scroll interno */
@media (min-width: 768px) {
  .movements-col {
    position: relative;
  }
  .movements-card {
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(var(--bs-gutter-x) * 0.5);
    right: calc(var(--bs-gutter-x) * 0.5);
  }
}
.movements-card {
  display: flex;
  flex-direction: column;
}
.movements-body {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}
</style>
